import React from "react";
import BusableWidget, { VIEW_BY_LINK } from "./BusableWidget";
import PassengerTimetables from "./PassengerTimetables";
import { hasPassengerTimetables } from "../data/passengerTimetables";

// Regions with published TfNSW passenger routes show a static link list on the
// Passenger Timetables tab; the rest fall back to the widget's timetables view.
export default function RegionEmbed({ operatorId, activeLink, search }) {
    if (activeLink === "timetables" && hasPassengerTimetables(operatorId)) {
        return <PassengerTimetables operatorId={operatorId} />;
    }

    return (
        <BusableWidget
            operatorId={operatorId}
            view={VIEW_BY_LINK[activeLink]}
            search={search}
        />
    );
}
